//================================================================
//  Component: Tooltip
//================================================================

//  Purpose: This is the standard tooltip

//  Properties:
//    - message = {A string, this is the tooltip text}
//    - children = {HTML, this is the content for the tooltip}

//  Example:
//    <Tooltip
//      message={'Coming Soon!'}
//      children={<button>Subscribe</button>}
//    ></Tooltip>    

//================================================================


//Libraries
import React from 'react';

//Contexts

//Components

//Functions

//Images

export default function Tooltip({ 
    message, 
    children 
}) {

    return (
        <div className='group relative flex'>
            {children}
            <span hidden={message?.length === 0 || message?.length === undefined ? true : false} className='w-max absolute top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 z-10'>
                {message}
            </span>
        </div>
    )
}
